var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9068 6H2.99414V42H44.9068V6Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9 9L5.9873 41.8V42H44.9062L47.9 9Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.9 9L5.9873 41.8V42H44.9062L47.9 9Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9873 41.7992V41.9992L41.9125 13.8992V13.6992L5.9873 41.7992Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9131 9L44.9068 6C46.6033 6 47.9006 7.3 47.9006 9V39C47.9006 40.7 46.6033 42 44.9068 42H41.9131V9Z",
    fill: "#B93221"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98753 9L2.99376 6C1.2973 6 0 7.3 0 9V39C0 40.7 1.2973 42 2.99376 42H5.98753V9Z",
    fill: "#D23F31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7342 42L0.898439 11.1L23.9504 20.5L47.9005 9V39C47.9005 40.7 46.6032 42 44.9068 42H31.7342Z",
    fill: "url(#paint0_radial_2646_14319)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9064 6H2.99376C1.2973 6 0 7.3 0 9C0 10 0.49896 10.9 1.2973 11.4L23.9501 27.7L46.6029 11.4C47.4012 10.9 47.9002 10 47.9002 9C47.9002 7.3 46.6029 6 44.9064 6Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9505 27.7L44.9068 6H2.99414L23.9505 27.7Z",
    fill: "#EEEEEE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7027 11.4C47.501 10.9 48 10 48 9C48 7.3 46.7027 6 45.0062 6H44.0083L24.0499 20.5L3.99168 6H2.99376C1.2973 6 0 7.3 0 9C0 10 0.49896 10.9 1.2973 11.4L23.9501 27.7L46.7027 11.4Z",
    fill: "#DB4437"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M44.9064 6H2.99376C1.2973 6 0 7.3 0 9V9.20001C0 7.50001 1.2973 6.20001 2.99376 6.20001H44.9064C46.6029 6.20001 47.9002 7.50001 47.9002 9.20001V9C47.9002 7.3 46.6029 6 44.9064 6Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M46.7027 11.2004L23.9501 27.5004L1.2973 11.2004C0.598752 10.7004 0.0997921 9.80038 0 8.90038V9.00039C0 10.0004 0.49896 10.9004 1.2973 11.4004L23.9501 27.7004L46.6029 11.4004C47.4012 10.9004 47.9002 10.0004 47.9002 9.00039V8.90038C47.9002 9.80038 47.4012 10.7004 46.7027 11.2004Z",
    fill: "#3E2723"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9064 6H2.99376C1.2973 6 0 7.3 0 9V39C0 40.7 1.2973 42 2.99376 42H44.9064C46.6029 42 47.9002 40.7 47.9002 39V9C47.9002 7.3 46.6029 6 44.9064 6Z",
    fill: "url(#paint1_radial_2646_14319)",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2646_14319",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.865604 11.0714) scale(55.1069 55.2217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2646_14319",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.86809 6.8745) scale(57.4296 57.5492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.108598b9f585134e0bce43f3be027384.svg";
export { ForwardRef as ReactComponent };